import type { Tq2QuestionGroupProps } from "../models/tech-form-page.models";

export const Tq2BallastingCapacityGroup = ({ children }: Tq2QuestionGroupProps) => (
  <fieldset className="mb-6 rounded-md border p-4">
    <legend className="px-2 text-base font-semibold">Ballasting and de-ballasting capacities</legend>
    <div className="grid max-w-4xl grid-cols-1 gap-4 md:grid-cols-2">{children}</div>
  </fieldset>
);
